import { graphqlClient } from '@/lib/graphql-client';
import { buildGetKpiConfigurationQuery } from '../graphql/queries';
import { INSERT_KPI_CONFIGURATION_MUTATION } from '../graphql/mutations';
import { KpiConfiguration } from '../types/kpi-configuration.types';
import { KpiConfigurationFormValues } from '../schemas/kpi-configuration-form-schema';
import { toKpiConfigurationInput } from '../utils/kpi-configuration';

/**
 * The effective configuration is the newest saved row; null until an admin has saved one. The
 * query sorts newest first on the server, so only the first row is fetched, like the old
 * `OrderByDescending(x => x.CreateDate).FirstOrDefaultAsync()`.
 */
export const getKpiConfiguration = async (): Promise<KpiConfiguration | null> => {
  const result = await graphqlClient.query<{
    KpiConfigurations: { items: KpiConfiguration[] };
  }>({
    query: buildGetKpiConfigurationQuery({}, 1, 1),
  });
  return result.KpiConfigurations.items[0] ?? null;
};

export const saveKpiConfiguration = async (values: KpiConfigurationFormValues) => {
  return graphqlClient.mutate({
    query: INSERT_KPI_CONFIGURATION_MUTATION,
    variables: { input: toKpiConfigurationInput(values) },
  });
};
